import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import DigitalNotice from './components/DigitalNotice';
import IncludedSection from './components/IncludedSection';
import HowItWorks from './components/HowItWorks';
import Reviews from './components/Reviews';
import ProductDetails from './components/ProductDetails';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-[#faf9f6] text-stone-800 font-sans selection:bg-amber-200">
      <Header />
      <main>
        <Hero />
        <DigitalNotice />
        <IncludedSection />
        <HowItWorks />
        <Reviews />
        <ProductDetails />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export default App;